class StorageRepository {
    constructor(private storage: Storage) {}

    get = (key: string) => {
        try {
            const item = this.storage.getItem(key);
            if (item === null) return null;
            return JSON.parse(item);
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    set = (key: string, value: unknown) => {
        try {
            this.storage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.error(e);
        }
    };

    remove = (key: string) => {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            console.error(e);
        }
    };

    clear = () => {
        try {
            this.storage.clear();
        } catch (e) {
            console.error(e);
        }
    };
}

export const localStorageWrapper = new StorageRepository(localStorage);
export const sessionStorageWrapper = new StorageRepository(sessionStorage);
